module.exports = __webpack_public_path__ + "img/logo-icon.2fb3dec0.svg";